import { useMutation } from 'react-query'

import { postCreateCampaignsAPI } from "api/campaign-voucher";
import { CampaignCreateFormTypes } from "schemas/campaign-voucher-schemas";
import { toast } from 'react-toastify';

interface ApiError {
  outcomeCode?: string
  outcomeMessage?: string
  outcomeUserMessage?: string
}

export const useCampaignCreate = () => {

  const mutationFn = (mutationData: { formData: CampaignCreateFormTypes }) => {
    const { formData } = mutationData;
    return postCreateCampaignsAPI(formData);
  };

  const mutation = useMutation<unknown, ApiError, { formData: CampaignCreateFormTypes }>({
    mutationFn,
    onError: (error) => {
      console.log("error", error)
      const message = error.outcomeMessage || 'Failed to create campaign.'
      toast.error(message)
    },
    onSuccess() {
      // queryClient.invalidateQueries(QUERY_KEYS.VOUCHER_LIST);
    },
  })

  return mutation;
};
